import moment from 'moment';


export function getTotalCost(candidateFees, candidatesLength) {
    let totalCost = 0;
    candidateFees.forEach(candidateFee => {
        totalCost += parseFloat(candidateFee);
    });
    const ourFee = DJ_CONST.OUR_FEE_COEFFICENT * candidatesLength;

    totalCost = totalCost + ourFee;
    return {totalCost, ourFee};
}

export function updateCandidatePay(candidateId, pay, hours, index, curPay, candidateHours) {
    curPay[index] = pay;
    candidateHours[index] = [hours, candidateId];
    return {candidatePay: curPay, candidateHours: candidateHours};
}

export function getShiftDuration(shift) {
    let duration = 0;

    if (Object.keys(shift).length) {
        const duration_in_minutes = moment(shift.end_time).diff(moment(shift.start_time), 'minutes');
        const hours = parseInt(duration_in_minutes/60);
        const minutes = parseInt(duration_in_minutes%60);

        duration = parseFloat(hours + minutes/60);
    }

    return duration.toFixed(2);
}



/** WEBPACK FOOTER **
 ** ./app/src/utils/shiftFees.js
 **/